import { Routes } from '@/routes';

export default {
	'cart.view': () => import('@/modules/ecommerce/cart'),
	'cart.update': () => import('@/modules/ecommerce/cart'),
	'cart.checkout': () => import('@/modules/ecommerce/cart'),
	'cart.manager.index': () => import('@/modules/ecommerce/index'),
} as Routes;
